// extracted by mini-css-extract-plugin
export default {"wrapper":"MapCardNew_wrapper__q5rVR"};